import type { CreateCourseReview201Reviewer } from './createCourseReview201Reviewer';

export type CreateCourseReview201 = {
  /** 리뷰 코멘트 */
  comment: string;
  /** 리뷰 작성 시각 */
  readonly createdAt: string;
  /** 리뷰 고유 ID */
  id: number;
  /** 별점 (1-5) */
  rating: number;
  /** 리뷰 작성자 요약 정보 */
  reviewer: CreateCourseReview201Reviewer;
  /** 리뷰 마지막 수정 시각 */
  readonly updatedAt: string;
};
